export default __webpack_public_path__ + "static/magnet-a1986c6b8e4d5ca64e3bd255185104b4.jpg";